import React, { Fragment, PureComponent } from 'react';
import {
    Divider, Card, Tabs,
} from 'antd'

import ComSearching from '../../components/searching'
import ComStaticSearch from '../../components/staticSearch'
import ComMultipleSearching from '../../components/multipleSearch'


export default class HomePage extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            dataSource: [],
            setDefPinCode: '',// "Dhan_1V3#"

            classes: "",
            destination: "",
            end_time: "",
            origin: "",
        }
    }


    searching = (_parameterSearching) => {
        this.setState(_parameterSearching)
    }

    render() {
        let {
            classes,
            destination,
            end_time,
            origin
        } = this.state


        return (
            <Fragment>

                <Card key={12} bordered={false} title={"Parameter"}>
                    <ComSearching search={this.searching} />
                </Card>

                {/* NOTE Processing PIN CODE  */}
                {/*
                    <Divider />
                    <Typography.Text>Pin Code</Typography.Text>
                    <Input.Password
                        disabled={btnLoading}
                        placeholder="Set Pin"
                        onChange={(e) => this.setState({ setPinCode: e.target.value })}
                    /> 
                */}

                <Divider />
                <Tabs defaultActiveKey={2} style={{ marginLeft: 10, marginRight: 10 }}>
                    <Tabs.TabPane tab="Static Search">
                        {/* REVIEW Searching */}
                        <ComStaticSearch
                            classes={classes}
                            destination={destination}
                            end_time={end_time}
                            origin={origin}
                        />
                    </Tabs.TabPane>


                    {/* Multiple Search */}
                    <Tabs.TabPane tab="Multiple Search (Domestic)" key={2}>
                        <ComMultipleSearching
                            classes={classes}
                            destination={destination}
                            end_time={end_time}
                            origin={origin}
                        />
                    </Tabs.TabPane>
                </Tabs>

                <br /> <br />
                <br /> <br />
                <br /> <br />
                <br /> <br />
                <br /> <br />
                <br /> <br />
            </Fragment >
        );
    }
}

